// Copyright (C) 2017-2023 Smart code 203358507

const VideosMenu = require('./VideosMenu');

module.exports = VideosMenu;
